import ReportCreationScreen from '@screens/ReportCreation/ReportCreationScreen';

export default ReportCreationScreen;
